export function getContractRouteOfCurrentURL() {
  const paths = window.location.pathname.split("/");
  return `/${paths[1]}/contract`;
}
